import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, useNavigate } from 'react-router-dom';
import { AppBar, Toolbar, Typography, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, TextField, Container, Grid, Paper, List, ListItem, ListItemText, Card, CardMedia } from '@mui/material';
import CryptoJS from 'crypto-js';
import Calendar from './components/Calendar';
import AddEvent from './components/AddEvent';
import AddToDatabase from './components/AddToDatabase';
import TableData from './components/TableData';
import AddEmployee from './components/AddEmployee';
import AddClient from './components/AddClient';
import CalendarWeek from './components/CalendarWeek';
import TableEmployees from './components/TableEmployees';
import TableClients from './components/TableClients';
import ClientDetails from './components/ClientDetails';
import AddProduct from './components/AddProduct';
import TableProducts from './components/TableProducts';

const AppNavbar = () => {
  const [open, setOpen] = React.useState(false);
  const [password, setPassword] = React.useState('');
  const [errorOpen, setErrorOpen] = React.useState(false);
  const navigate = useNavigate();

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setPassword(''); // Clear the password field
  };

  const handleErrorClose = () => {
    setErrorOpen(false);
    setPassword(''); // Clear the password field
  };

  const handleLogin = () => {
    const hashedPassword = CryptoJS.SHA256(password).toString();

    if (hashedPassword === CryptoJS.SHA256('Iga9090123*').toString()) { // Iga9090123*
      localStorage.setItem('LOGGED_IN', 'true');
      handleClose();
      navigate('/Calendar');
    } else {
      setErrorOpen(true);
    }
  };

  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      handleLogin();
    }
  };

  return (
    <>
      <AppBar position="static" sx={{ background: 'linear-gradient(to right, #94651c, #9d4730, #853031, #721043, #3d2357, #0b4453, #2d5b55, #606922)' }}>
        <Toolbar>
          <Typography variant="h6" sx={{ flexGrow: 1 }}>
            Strona Główna
          </Typography>
          <Button color="inherit" onClick={handleClickOpen}>
            Panel Administratora
          </Button>
          <Dialog open={open} onClose={handleClose}>
            <DialogTitle>Logowanie</DialogTitle>
            <DialogContent>
              <DialogContentText>
                Podaj hasło, aby uzyskać dostęp do panelu administratora.
              </DialogContentText>
              <TextField
                autoFocus
                margin="dense"
                label="Hasło"
                type="password"
                fullWidth
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                onKeyPress={handleKeyPress}
              />
            </DialogContent>
            <DialogActions>
              <Button onClick={handleClose} color="primary">
                Anuluj
              </Button>
              <Button onClick={handleLogin} color="primary">
                Zaloguj
              </Button>
            </DialogActions>
          </Dialog>
          <Dialog open={errorOpen} onClose={handleErrorClose}>
            <DialogTitle>Błąd</DialogTitle>
            <DialogContent>
              <DialogContentText>
                Podałeś złe hasło.
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleErrorClose} color="primary">
                Zamknij
              </Button>
            </DialogActions>
          </Dialog>
        </Toolbar>
      </AppBar>
    </>
  );
};

const HomePage = () => {
  return (
    <Container sx={{ marginBottom: '100px' }}>
      <Grid container spacing={3} direction="column" alignItems="center">
        <Grid item xs={12}>
          <Typography variant="h3" style={{ marginTop: '5rem' }}>
            STUDIO SUNFLOWER
          </Typography>
          <Typography variant="h6">
            Konopackich, 20, 87-100, Toruń
          </Typography>
        </Grid>

        <Grid item xs={12} style={{ width: '70%' }}>
          <Paper elevation={3} style={{ padding: '1rem' }}>
            <Typography variant="h5" style={{ marginBottom: '1rem', textAlign: 'center', paddingRight: '100px' }}>
              Usługi:
            </Typography>
            <Grid container spacing={2}>
              {/* Kolumna 1 */}
              <Grid item xs={12} sm={6}>
                <List>
                  <ListItem>
                    <ListItemText primary="Strzyżenie Damskie" secondary="150zł, ok. 1 godzina" />
                  </ListItem>
                  <ListItem>
                    <ListItemText primary="Włosy do ramion" secondary="440zł, ok. 4 godziny" />
                  </ListItem>
                  <ListItem>
                    <ListItemText primary="Włosy długie/do łopatki" secondary="480zł, ok. 5 godzin" />
                  </ListItem>
                  <ListItem>
                    <ListItemText primary="Włosy bardzo długie" secondary="560zł, ok. 5 godzin 30 minut" />
                  </ListItem>
                  <ListItem>
                    <ListItemText primary="Tonowanie włosów" secondary="220zł, ok. 1 godzina 30 minut" />
                  </ListItem>
                </List>
              </Grid>

              {/* Kolumna 2 */}
              <Grid item xs={12} sm={6}>
                <List>
                  <ListItem>
                    <ListItemText primary="Modelowanie" secondary="80zł, ok. 1 godzina" />
                  </ListItem>
                  <ListItem>
                    <ListItemText primary="Loki/Fale" secondary="120zł, ok. 1 godzina 40 minut" />
                  </ListItem>
                  <ListItem>
                    <ListItemText primary="Częściowe Upięcie" secondary="170zł, ok. 1 godzina 40 minut" />
                  </ListItem>
                  <ListItem>
                    <ListItemText primary="Pełne Upięcie" secondary="220zł, ok. 2 godziny" />
                  </ListItem>
                  <ListItem>
                    <ListItemText primary="Kuracja ICON" secondary="250zł, ok. 1 godzina 30 minut" />
                  </ListItem>
                </List>
              </Grid>
            </Grid>
          </Paper>
        </Grid>


        <Grid item xs={12} style={{ width: '100%', marginTop: '40px' }}>
          <Typography variant="h5" style={{ marginBottom: '1rem' }}>
            NASZE PORTFOLIO
          </Typography>
          <Grid container spacing={2}>
            {[1, 2, 3, 4].map((item) => (
              <Grid item xs={12} sm={6} md={3} key={item}>
                <Card>
                  <CardMedia
                    component="img"
                    alt={`Portfolio ${item}`}
                    height="140"
                    image={`images/${item}.png`}
                    title={`Portfolio ${item}`}
                  />
                </Card>
              </Grid>
            ))}
          </Grid>
        </Grid>

        <Grid item xs={12} style={{ width: '100%' }}>
          <Paper elevation={3} style={{ padding: '1rem' }}>
            <Typography variant="h5" style={{ marginBottom: '1rem' }}>
              Udogodnienia
            </Typography>
            <List>
              <ListItem>
                <box-icon type='solid' name='car'></box-icon>&nbsp;<ListItemText primary="Parking" />
              </ListItem>
              <ListItem>
                <box-icon name='credit-card-alt' type='solid' ></box-icon>&nbsp;<ListItemText primary="Akceptacja kart płatniczych" />
              </ListItem>
              <ListItem>
                <box-icon type='solid' name='coffee'></box-icon>&nbsp;<ListItemText primary="Kawa / Herbata" />
              </ListItem>
            </List>
          </Paper>
        </Grid>

        {/* Google Maps Section */}
        <Grid item xs={12} style={{ width: '100%', marginTop: '2rem' }}>
          <Typography variant="h5" style={{ marginBottom: '1rem' }}>
            Jak Dojechać
          </Typography>
          <iframe
            src="https://maps.google.com/maps?q=Konopackich%2020,%2087-100%20Toru%C5%84&t=&z=15&ie=UTF8&iwloc=&output=embed"
            width="100%"
            height="450"
            style={{ border: 0 }}
            allowFullScreen
            loading="lazy"
          ></iframe>
        </Grid>

        {/* Contact Information Section */}
        <Grid item xs={12} style={{ width: '100%', marginTop: '2rem', textAlign: 'center' }}>
          <Typography variant="h5" style={{ marginBottom: '1rem' }}>
            Kontakt
          </Typography>
          <div style={{ fontSize: '2rem' }}>
            <div>
              <box-icon type='solid' name='phone' /> +48 609 738 982
            </div>
            <div>
              <box-icon name='envelope' /> contact@studio-sunflower.pl
            </div>
            <div>
              <box-icon type='solid' name='map-pin' /> Konopackich 20, 87-100 Toruń
            </div>
          </div>
        </Grid>
      </Grid>
    </Container>
  );
};

const App = () => {
  // useEffect(() => {
  //   localStorage.removeItem('LOGGED_IN');
  // }, []);
  

  return (
    <Router>
      <AppNavbar />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/Calendar" element={<Calendar />} />
        <Route path="/AddEvent" element={<AddEvent />} />
        <Route path="/AddToDatabase" element={<AddToDatabase />} />
        <Route path="/TableData" element={<TableData />} />
        <Route path="/AddEmployee" element={<AddEmployee />} />
        <Route path="/AddClient" element={<AddClient />} />
        <Route path="/CalendarWeek" element={<CalendarWeek />} />
        <Route path="/TableEmployees" element={<TableEmployees />} />
        <Route path="/TableClients" element={<TableClients />} />
        <Route path="/client/:clientId" element={<ClientDetails />} />
        <Route path="/AddProduct" element={<AddProduct />} />
        <Route path="/TableProducts" element={<TableProducts />} />
      </Routes>
    </Router>
  );
};

export default App;
